import Carousel from './Carousel.vue';

export * from './types';
export default Carousel;



// WEBPACK FOOTER //
// ./src/pages/profile/components/carousel/index.ts